"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _iconTriangleDownBlack = _interopRequireDefault(require("../../images/icon-triangle-down-black.svg"));

var _stitches = require("../../stitches.config");

var StyledSelect = (0, _stitches.styled)('select', {
  appearance: 'none',
  background: "transparent url(".concat(_iconTriangleDownBlack.default, ") no-repeat 100% 50%"),
  border: '0',
  borderRadius: '5px',
  fontSize: '$small',
  fontWeight: '$medium',
  outline: '0',
  padding: '10px 16px',
  width: '98%',
  color: '$inputText',
  '&:hover': {
    cursor: 'pointer'
  }
});
/**
 * A simple select meant to be mainly used in the Input component.
 */

var Select = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var id = _ref.id,
      name = _ref.name,
      options = _ref.options;
  return /*#__PURE__*/_react.default.createElement(StyledSelect, {
    id: id,
    name: name,
    ref: ref
  }, Array.isArray(options) ? options.map(function (option) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: "".concat(name, "-").concat(option),
      value: option
    }, option);
  }) : Object.keys(options).map(function (key) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: "".concat(name, "-").concat(key),
      value: key === 'noValue' ? '' : key
    }, options[key]);
  }));
});
Select.defaultProps = {};
Select.displayName = 'Select';
var _default = Select;
exports.default = _default;